module.exports = __webpack_public_path__ + "assets/img/NPC001.d97e7686.png";